import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChartWidget } from './components/chart/ChartWidget';

export const mount = (props) => {
    const container = document.getElementById(props.containerId)
    const root = createRoot(container);
    return root.render(<ChartWidget {...props} />);
}